import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export type AppToastSeverity = 'success' | 'error' | 'info' | 'warning';

interface Props {
  open: boolean;
  message: string;
  severity?: AppToastSeverity;
  onClose: () => void;
}

export default function AppToast({ open, message, severity = 'info', onClose }: Props) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
